import type { Routes } from '@angular/router';

export const authFailRoutes: Routes = [
  {
    path: 'auth-fail',
    loadComponent: () => import('./auth-fail.component').then((m) => m.AuthFailComponent),
  },
];
